import { createFileRoute } from "@tanstack/react-router";
import EmpresasDeServicios from "../pages/EmpresasDeServicios";

export const Route = createFileRoute("/empresas-de-servicios")({
  component: EmpresasDeServicios,
});
